"use client"
/* */
class TableCell {
  row;
  renderFn;
  componentProps;
  constructor(row, shape = {}) {
    const { renderFn, ...rest } = shape;
    this.row = row;
    this.renderFn = renderFn;
    this.componentProps = rest;
  }
}

export { TableCell };
//# sourceMappingURL=TableCell.mjs.map
